import React from "react";

import styles from "./ToggleSwitch.module.css";

interface ToogleSwitchProps {
  handler: () => void;
  checked: boolean;
}

const ToggleSwitch: React.FC<ToogleSwitchProps> = ({ handler, checked }) => {
  return (
    <label className={styles.switch}>
      <input type="checkbox" onChange={handler} checked={checked} />
      <span className={[styles.slider, styles.round].join(" ")}></span>
    </label>
  );
};

export default ToggleSwitch;
